<template>
  <div class="adm-content-item" :class="[`ui--${type}`]" v-if="value">
    <div class="adm-content-item__title">
      <span class="pull-right">
        <span class="adm-split">
          <span class="t-s">
            <iv-poptip v-if="value.audit==2" trigger="hover" title="审核批注" placement="left">
              <iv-icon type="ios-information" size="12" style="color:#2d8cf0"></iv-icon>
              <div slot="content" v-html="value.comment.replace(/\n/g,'<br>')"></div>
            </iv-poptip>
            {{ ['','未审核','不通过','已通过'][value.audit] }}
          </span>
          <slot name="buttons"></slot>
        </span>
      </span>
      <slot name="checkbox"></slot>
      <h5 style="color:#3C3C3C" :title="`编号：${value.id}`">
        <span>{{ !!value.title ? value.title : "" }}</span>
        <!-- <span>({{ !!value.punishmentNumber ? value.punishmentNumber : "" }})</span> -->
      </h5>
      <span class="adm-split">
        <a
          class="item_edit"
          :rel="!!value.originUrl ? 'noopener noreferrer': ''"
          :href="!!value.originUrl ? value.originUrl : previewUrl"
          :target="!!value.originUrl?'__brank':'punishmentPreviewWindow'"
          @click="onOriginClick">
          <iv-icon type="md-open" size="16" style="vertical-align:text-bottom" />
        </a>
        <a
          v-if="value.targetType==1"
          href="javascript:;"
          class="item_edit"
          title="青悦处罚快照"
          @click="$emit('qySnapshot', value)">
          <iv-icon type="md-image" size="16" style="vertical-align:text-bottom" />
        </a>
        <span>处罚时间：{{ !!value.punishDate ? value.punishDate : ""}}</span>
        <span>爬取时间：{{ !!value.crawlTime ? value.crawlTime : ""}}</span>
        <span>处罚机关：{{ !!value.punishmentAuthority ? value.punishmentAuthority : ""}}</span>
      </span>
      <span v-if="type=='audit'" class="adm-split" style="margin:0 20px">
        <a href="javascript:;" @click="$operationLog.show({ type:'sentiment', sentimentType:'punishment', sentimentId: value.id })">查看日志</a>
        <a href="javascript:0" @click="$emit('Edit')" v-rbac-allow="['publicSentiment', 'edit']">编辑</a>
      </span>
      <span v-else class="item_edit" style="margin-left:10px" @click="shownTitleModal" v-rbac-allow="['publicSentiment', 'edit']">
         <iv-icon type="ios-create-outline" size="16" style="vertical-align:text-bottom" />修改标题</span>
    </div>
    <div class="adm-content-item__tip" >
      <span>
        公司名称：<span class="t-s">{{ value.companyInfo.abbreviation }} </span>
      </span>
      <span>
        持股比例：<span class="t-s">{{ value.holdingRatio * 100 }}%</span>
      </span>
      <span>
        被处罚公司：<span class="t-s">{{ value.unitName }}</span>
      </span>
    </div>
    <div class="adm-content-item__detail">
      <div class="adm-content-item__meta meta-01">
         <div>
           公司名称：<span class="t-s">{{ value.companyInfo.abbreviation }} </span>
         </div>
        <div>
          持股比例：<span class="t-s">{{ value.holdingRatio * 100 }}%</span>
        </div>
        <div>
          被处罚公司：<span class="t-s">{{ value.unitName }}</span>
        </div>
      </div>
      <div class="adm-content-item__meta">
        <div>
          <span>公司罚款：<span class="t-s">{{ value.institutionalFines }} </span></span>
        </div>
        <div><span>没收违法所得：<span class="t-s">{{ value.confiscateIllegalGains }} </span></span></div>
        <div><span>个人罚款：<span class="t-s">{{ value.personalFines }} </span></span></div>
        <div>
          行政处罚分类：<span class="t-s">{{ value.category }}</span>
        </div>
        <div><a href="javascript:;" @click="$emit('Detail')" v-rbac-allow="['publicSentiment', 'edit']">详情>></a></div>
      </div>
      <div class="adm-content-item__meta">
        <div>
          一级指标：<span class="t-s">{{ value.firstTargetName }}</span>
        </div>
        <div>
          二级指标：<span class="t-s">{{ value.secondTargetName }}</span>
        </div>
        <div>
          三级指标：<span class="t-s">{{ value.thirdTargetName }}</span>
        </div>
      </div>
      <div class="adm-content-item__meta">
        <div>
          <div>评分：<span class="t-s" style="font-size:18px;">{{ value.score }}</span></div>
          <div>总得分：<span class="t-s" style="font-size:18px;">{{ value.weightedScore }}</span></div>
        </div>
        <div v-if="type!='audit'">
          <iv-poptip trigger="hover" title="得分情况" width="350" placement="left">
            <span>得分情况：</span>
            <span class="t-a" v-if="value.dimensionInfo.length<=0||value.dimensionInfo.some(item => item.dimensionScore <= 0)">未评分</span>
            <span v-else class="t-a">已评分</span>
            <div slot="content" class="adm-flex-group ui-wrap">
              <div class="ui-grow" style="width:50%;padding:0 10px;" v-for="dimension in value.dimensionInfo" :key="dimension.dimensionId">
                {{ dimension.dimension }}({{ dimension.dimensionScore }})<br />
                <iv-progress :percent="(dimension.dimensionScore / dimension.dimensionWeight) * 100" hide-info :stroke-width="6" />
              </div>
            </div>
          </iv-poptip>
        </div>
        <div v-else>
          <div class="adm-flex-group ui-wrap">
            <div
              class="ui-grow"
              v-for="dimension in value.dimensionInfo"
              :key="dimension.dimensionId">
              <div style="width:120px">
                {{ dimension.dimension }}({{ dimension.dimensionScore }})<br />
                <iv-progress :percent=" (dimension.dimensionScore / dimension.dimensionWeight) * 100" hide-info :stroke-width="6" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <slot></slot>
    </div>
    <iv-modal :mask-closable="false" title="修改标题" width="450" :closable="false" v-model="titleModal"
      @on-cancel="titleModal = false">
      <iv-form :model="formValidate" :rules="ruleValidate" ref="formValidate" label-position="top" inline>
        <iv-form-item label="标题" prop="title">
          <iv-input type="text" v-model="formValidate.title" placeholder="请输入标题" style="width:400px"></iv-input>
        </iv-form-item>
      </iv-form>
      <iv-button type="text" size="large" slot="footer" @click="titleModal = false">取消</iv-button>
      <iv-button type="primary" size="large" slot="footer" @click="update">确定</iv-button>
    </iv-modal>
  </div>
</template>
<style lang="scss" scoped>
.adm-content-item {
  font-size: 12px;
  padding: 15px 12px;
  color: #999999;
  &__title {
    font-size: 12px;
    margin-bottom: 0.5em;
    h5{
      display: inline;
      font-size: 14px;
    }
    small {
      color: #aaa;
      font-weight: normal;
      margin-left: 0.625em;
    }
    .item_edit {
      color: #2d8cf0;
      &:hover {
        cursor: pointer;
      }
    }
  }
  &__detail {
    display: flex;
    justify-content: flex-start;
    margin: 0 -15px;
    text-align: left;
    > *{
      padding: 0 15px;
    }
  }
  &__meta {
    // flex-grow: 1;
    // flex-shrink: 1;
    position: relative;
    &::after {
      content: "";
      width: 1px;
      border-right: 1px solid #dddddd;
      position: absolute;
      right: 0;
      top: 0;
      bottom: 0;
    }
    > div {
      line-height: 22px;
      display: flex;
      align-items: center;
      margin-bottom: 5px;
      display: block;
    }
    .negative > .ivu-select >>> .ivu-select-selection {
      background: #ed4c4c;
    }
    .positive > .ivu-select >>> .ivu-select-selection {
      background: #33ab15;
    }
    .item_section {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box; //作为弹性伸缩盒子模型显示。
      -webkit-box-orient: vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列
      -webkit-line-clamp: 3; //显示的行
    }
  }

  &__content {
    display: flex;
    justify-content: space-between;
  }
  &__buttons {
    opacity: 1;
    transition: opacity 0.5s ease-out;
    a,
    button {
      margin-left: 0.625em;
      &:first-child {
        margin-left: 0;
      }
    }
  }
  &__type {
    // vertical-align: middle;
    margin-left: 7px;
  }
  &__read {
    color: #2d8cf0;
  }
  &__exclude {
    color: #ed4c4c;
  }
  &__not {
    color: #666;
  }
  .t-s {
    color: #666;
  }
  .t-a {
    color: #2d8cf0;
    text-decoration: underline;
  }
  .meta-01{
    display: block;
    @media screen and (max-width:1366px) {
      display: none;
    }
  }
  &__tip{
    display: none;
    margin-bottom: 1em;
    > span{
      margin-right:10px;
    }
    @media screen and (max-width:1366px) {
      display: block;
    }
  }

  &.ui--draft{
     .adm-content-item__meta {
      flex-shrink: 0;
      &:nth-child(1) {
        flex-grow: 1;
        max-width: 350px;
        // flex-shrink: 1;
        // width: 50%;
        @media screen and (max-width:1366px) {
          max-width: 450px;
        }
      }
      &:nth-child(2) {
        flex-grow: 1;
        // flex-shrink: 1;
        // width: 50%;
        .overflow{
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
      &:last-child {
        flex-grow: 0;
        flex-shrink: 1;
      }
      &:nth-child(3) {
        width: 250px;
        flex-grow: 0;
        flex-shrink: 1;
        @media screen and (max-width:1366px) {
          min-width: 250px;
        }
      }
      &:nth-last-child(2) {
        width: 150px;
        &::after {
          display: none;
        }
      }
      &:last-child{
        flex-grow: 0;
      }
    }
  }
  &.ui--audit{
    .adm-content-item__meta {
      &:nth-child(1) {
        width: 250px;
      }
      &:nth-child(2) {
        flex-shrink: 0;
        width: 200px;
        .overflow{
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
      &:nth-child(3) {
        flex-shrink: 0;
        width: 250px;
      }
      &:nth-child(4) {
        flex-grow: 1;
      }
      &:last-child{
        &::after {
          display: none;
        }
      }
    }
  }
}
</style>
<script>
export default {
  props: {
    value: Object,
    type: {
      type: String,
      default: "draft" //可选：draft, audit；draft为收录入前的草稿，audit为收录后的样式
    },
  },
  data() {
    let routerJump = this.$router.resolve({ name:'storage_preview', params:{ storageName:'PUNISHMENT_PREVIEW' } })
    return {
      titleModal: false,
      formValidate: {title:""},
      ruleValidate: {
        title: [{ required: true, message: "请输入标题", trigger: "change" }]
      },
      previewUrl: routerJump.href,
    };
  },
  methods: {
    find(arr, val, field = "id") {
      return arr.find(item => item[field] == val) || {};
    },
    onOriginClick(){
      const { title,content } = this.value
      localStorage.setItem("PUNISHMENT_PREVIEW", JSON.stringify({ title, content }))
      // let routerJump = this.$router.resolve({ name:'storage_preview', params:{ storageName:'PUNISHMENT_PREVIEW' } })
      // const href = originUrl ? originUrl : routerJump.href
      // window.punishmentPreviewWindow = window.open(href, originUrl?'__brank':'punishmentPreviewWindow')
      // window.punishmentPreviewWindow.location.reload()
    },
    async update() {
      if (!this.$refs.formValidate.validate) return;
      this.$emit("title", { id: this.value.id, title: this.formValidate.title });
      this.titleModal = false;
    },
    shownTitleModal() {
      this.titleModal = true;
      this.formValidate.title = this.value.title;
    }
  },
};
</script>
